import {EntrySummary} from 'notebook/ELNConstants';
import {StageEntrySummary} from 'workflows/WorkflowConstants';

export interface EntriesByRunId {
  [runId: string]: StageEntrySummary | EntrySummary;
}

export enum AvailabilityStatus {
  AVAILABLE = 'AVAILABLE',
  IN_ENTRY = 'IN_ENTRY',
}
export const AVAILABLE_TEXT = 'Available';
export const USED_TEXT = 'In entry';
